import './toggle.scss';

export const OrderSummaryToggle = angular
    .module('checkout.components.orderSummary.orderSummaryToggle', [])
    .component('orderSummaryToggle', {
        template: `
            <button type="button" class="order-summary-toggle">
                <div layout layout-align="start center">
                    <span class="order-summary-toggle__text">
                        <span ng-if="$ctrl.collapsed">Show details</span>
                        <span ng-if="!$ctrl.collapsed">Hide details</span>
                    </span>
                    <i class="material-icons" ng-if="$ctrl.collapsed">arrow_drop_down</i>
                    <i class="material-icons" ng-if="!$ctrl.collapsed">arrow_drop_up</i>
                </div>
            </button>
        `,
        bindings: {
            collapsed: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/toggle/toggle.js